import React, {useEffect, useState } from 'react'
import Select from 'react-select'
import Mensagem from '../components/Mensagem'
import { adicionarComplemento as cadastrarProvidencia} from '../services/DenunciaServico'
import { obterTodasComStatusCadastrada } from '../services/DenunciaServico'
import { obterProvidencias, alterar as alterarProvidencia, excluir as excluirProvidencia } from '../api/ComplementoApi'

export default function Providencia(props) {

    const [mensagem, setMensagem] = useState('')
    const [denuncia, setDenuncia] = useState('') 
    const [listaDenuncias, setListaDenuncias] = useState([]) 
    const [providencia, setProvidencia] = useState('') 
    const [listaProvidencias, setListaProvidencias] =  useState([])
    const [narrativa, setNarrativa] = useState('') 
    
    useEffect(() => {
        setDenuncia('')
        setProvidencia('')
        props.setShowSpinner(true)
        obterTodasComStatusCadastrada()
        .then( denuncias => {
            setListaDenuncias(denuncias)
            setNarrativa('')
        })
        .catch( erroObterTodasComStatusCadastrada => {
            setMensagem(erroObterTodasComStatusCadastrada)
        })
    }, [props.preencherLista])

    const renderListaDenuncias = () => {
        return (
            listaDenuncias.map(denuncia => {
                 return { value:denuncia, label:denuncia.protocolo }
            })
        )
    }

    const selecionarDenuncia = item => {
        setDenuncia(item)
        obterProvidencias(item.label)
        .then( providencias => {
            setListaProvidencias(providencias)
            setProvidencia('')
            setNarrativa('')
            setMensagem({ tipo:'LIMPAR', texto:'' })
        })
        .catch( erroObterProvidencias => {
            setMensagem(erroObterProvidencias)
        })
    }

    const renderListaProvidencias = () => {
        return (
            listaProvidencias.map(providencia => {
                 return { value:providencia, label:providencia.narrativa.substring(0,40) }
            })
        )
    }

    const selecionarProvidencia = item => {
        setProvidencia(item)
        setNarrativa(item.value.narrativa)
    }

    const osDadosEstaoCorretos = () => {
        if (denuncia === "") {
            setMensagem({ tipo:'problema', texto:'Selecione um protocolo!' })
            return false
        }

        if (narrativa === "") {
            setMensagem({ tipo:'problema', texto:'Providência não pode estar em branco!' })
            return false
        }

        return true
    }

    const cadastrar = () => {
        if (!osDadosEstaoCorretos()) {
            return
        }
        props.setShowSpinner(true)
        cadastrarProvidencia({ protocolo:denuncia.value.protocolo, narrativa, status:'PROVIDENCIA' },[])
        .then( respEnvia => {
            props.setShowSpinner(false)
            setMensagem({ tipo:'sucesso', texto:'Providência cadastrada com sucesso!'})
        })
        .catch( msgErroEnvia => {
            setMensagem(msgErroEnvia)
            props.setShowSpinner(false)
        })
    }

    const alterar = () => {
        setMensagem({ tipo:'LIMPAR', texto:'' })
        if (!osDadosEstaoCorretos()) {
            return
        }
        props.setShowSpinner(true)
        alterarProvidencia({ ...providencia.value, narrativa })
        .then( respEnvia => {
            props.setShowSpinner(false)
            setMensagem(respEnvia)
        })
        .catch( msgErroEnvia => {
            setMensagem(msgErroEnvia)
            props.setShowSpinner(false)
        })
    }

    const excluir = () => {
        props.setShowSpinner(true)
        excluirProvidencia(providencia.value)
        .then( respEnvia => {
            props.setShowSpinner(false)
            setMensagem(respEnvia)
        })
        .catch( msgErroEnvia => {
            setMensagem(msgErroEnvia)
            props.setShowSpinner(false)
        })
    }

    const obterBotaoAtualizar = () => {
        if (denuncia === "" ) {
            return null
        }

        if (providencia === "") {
            if (narrativa === "") {
                return (
                    <button type="button" className="btn btn-primary mt-4" onClick={ cadastrar } disabled>Nova</button>
                )
            }

            return (
                <button type="button" className="btn btn-primary mt-4" onClick={ cadastrar }>Nova</button>
            )
        }

        if (narrativa === "") {
            return (
                <button type="button" className="btn btn-warning mt-4" disabled>Alterar</button>
            )
        }

        return (
            <button type="button" className="btn btn-warning mt-4" onClick={ alterar }>Alterar</button>
        )
    }

    const obterBotaoExcluir = () => {
        if (denuncia === "" || providencia === "") {
            return null
        }

        return(
            <button type="button" className="btn btn-danger mt-4" onClick={ excluir }>
                Excluir
            </button>
        )
    }

    if (props.formularioEmPauta !== "ProvidenciasGestor") {
        return null
    }

    return (
        <div className="molduraLeituraProtocolo">
            <Mensagem mensagem={ mensagem } />
            <br />
            <div className="card" style={{ width:480 }}>
                <div className="card-header"></div>
                <div className="card-body">
                    <div>
                        <label>Denúncias:</label>
                        <Select  
                            key="keyDenunciasCadastradas"
                            placeholder="Selecione um nº de protocolo..."
                            options={ renderListaDenuncias() }
                            value={ denuncia }
                            onChange={ selecionarDenuncia }
                        >
                        </Select> 
                    </div> 
                    <div className="mt-4">
                        <label>Providências:</label>
                        <Select  
                            key="keyProvidenciasCadastradas"
                            placeholder="Selecione uma..."
                            options={ renderListaProvidencias() }
                            value={ providencia }
                            onChange={ selecionarProvidencia }
                        >
                        </Select> 
                    </div>             
                    <div className="mt-4">
                        <label>Providência:</label>
                        <textarea
                            id="idProvidencia"
                            name="descricao-providencia"
                            type="textarea"
                            className="form-control"
                            rows="10"
                            placeholder="Descrição da providência"
                            value={ narrativa }
                            onChange={ event => setNarrativa(event.target.value) }
                        />
                    </div>
                    <div className="d-flex justify-content-between">
                        { obterBotaoAtualizar() }
                        { obterBotaoExcluir() }
                    </div>
                </div>
            </div>
        </div>
    )
}